(function () {
  function getItem(target) {
    return target && target.closest('[data-cart-drawer-upsell-item]');
  }

  function clampQuantity(input) {
    if (!input) return 1;
    const min = Number(input.getAttribute('min')) || 1;
    const max = Number(input.getAttribute('max')) || 10;
    let value = Number(input.value) || min;
    value = Math.max(min, Math.min(max, value));
    input.value = value;
    return value;
  }

  function updateVariant(select) {
    const item = getItem(select);
    if (!item) return;

    const option = select.options[select.selectedIndex];
    const addButton = item.querySelector('[data-cart-drawer-upsell-add]');
    const price = item.querySelector('[data-cart-drawer-upsell-price]');
    const quantityInput = item.querySelector('[data-cart-drawer-upsell-quantity-input]');

    if (addButton && option) addButton.dataset.variantId = option.value;
    if (price && option && option.dataset.priceHtml) price.textContent = option.dataset.priceHtml;

    if (quantityInput && option) {
      if (option.dataset.inventoryManagement === 'shopify' && option.dataset.inventoryPolicy === 'deny') {
        quantityInput.max = String(Math.max(1, Number(option.dataset.inventory) || 1));
      } else {
        quantityInput.max = '10';
      }
      clampQuantity(quantityInput);
    }
  }

  function setError(item, message) {
    const error = item && item.querySelector('[data-cart-drawer-upsell-error]');
    if (error) error.textContent = message || '';
  }

  function renderCart(parsedState) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState.sections) {
      cartDrawer.renderContents(parsedState);
      return;
    }

    if (window.location.pathname === window.routes.cart_url) {
      window.location.reload();
    }
  }

  async function addUpsell(button) {
    const item = getItem(button);
    if (!item || button.disabled) return;

    const quantityInput = item.querySelector('[data-cart-drawer-upsell-quantity-input]');
    const quantity = clampQuantity(quantityInput);
    const variantId = button.dataset.variantId;
    const cartDrawer = document.querySelector('cart-drawer');

    if (!variantId) return;

    setError(item, '');
    button.disabled = true;
    button.dataset.originalText = button.textContent;
    button.textContent = 'Dodaje se...';

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', String(quantity));

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const parsed = await response.json();

      if (!response.ok || parsed.status) {
        throw new Error(parsed.description || parsed.message || window.cartStrings.error);
      }

      renderCart(parsed);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-upsell', cartData: parsed, variantId });
    } catch (error) {
      setError(item, (error && error.message) || window.cartStrings.error);
      button.disabled = false;
      button.textContent = button.dataset.originalText || 'Dodaj';
    }
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-cart-drawer-upsell-variant]')) {
      updateVariant(event.target);
    }

    if (event.target.matches('[data-cart-drawer-upsell-quantity-input]')) {
      clampQuantity(event.target);
    }
  });

  document.addEventListener('click', (event) => {
    const dismissButton = event.target.closest('[data-cart-drawer-upsell-dismiss]');
    if (dismissButton) {
      const upsell = dismissButton.closest('[data-cart-drawer-upsell]');
      if (upsell) upsell.hidden = true;
      return;
    }

    const addButton = event.target.closest('[data-cart-drawer-upsell-add]');
    if (addButton) {
      addUpsell(addButton);
      return;
    }

    const quantityButton = event.target.closest('[data-cart-drawer-upsell-minus], [data-cart-drawer-upsell-plus]');
    if (!quantityButton) return;

    const quantity = quantityButton.closest('[data-cart-drawer-upsell-quantity]');
    const input = quantity && quantity.querySelector('[data-cart-drawer-upsell-quantity-input]');
    if (!input) return;

    const delta = quantityButton.matches('[data-cart-drawer-upsell-plus]') ? 1 : -1;
    input.value = String((Number(input.value) || 1) + delta);
    clampQuantity(input);
  });
})();
